import { Injectable, OnInit, Injector } from '@angular/core';
import {ParserService } from '../ws/ws.service';
import {environment} from '../../../../environments/environment';

import {ILayoutManager} from './layout-manager';
import {WsService2} from '../ws/ws.service';
@Injectable()
export class LayoutParserService extends ParserService{
    constructor(ws: WsService2){
       super(ws);
    }
    setManager(r:ILayoutManager){
        this.manager = r;
    }
    sendFullscreen(to){
        this.send("fullscreen", {to: to});
    }
   manager: ILayoutManager
   parseMessage(m){ 
       switch (m.cmd){
           case "changeLayout": this.manager.onLayout(m.layout); break;
           case "initialLayout": this.manager.onInitalLayout(m.layout); break;
           case "resize": this.manager.resize(); break;
           case "fullscreen": this.manager.onFullscreen(m.to); break;
    }
   }
   sendChangeLayout(layout){
       this.send("changeLayout", {layout: layout});
   }
 sendLayoutChanged(layout){
       this.send("layoutChanged", {layout: layout});
   }
sendResize(to){
    this.send("resize", {to: to});
}
}




// WEBPACK FOOTER //
// /app/src/app/wb/services/layout/layout-parser.service.ts